import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Icon } from "../../components/Icon";
import LocationPin from "../../icons/location-pin.svg";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import styles from "./GetDirectionLink.module.scss";
export const GetDirectionLink = ({ label, color = "black", ...rest }) => {
    const iconClasses = classNames(styles.iconBlack, {
        [styles.iconBlue]: color === "blue",
    });
    return (_jsxs("a", { ...rest, className: styles.getDirectionLink, children: [_jsx(Icon, { className: iconClasses, width: "22px", height: "22px", component: LocationPin }), _jsx(DEPRECATED_Typography, { className: styles.label, type: "p3", color: color, children: label })] }));
};
//# sourceMappingURL=GetDirectionLink.js.map